import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchRTPWithdrawTransaction from '@/hooks/useApi/useFetchRTPWithdrawTransaction';
import RTPWithdrawalInfo from './RTPWithdrawalInfo';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type RTPWithdrawalContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof RTPWithdrawalInfo>, 'transaction'>;

export default function RTPWithdrawalContainer({
  TransactionID,
  Notes,
  jwt,
  ELinxRequestID = '',
  ...props
}: RTPWithdrawalContainerProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { rtpWithdrawTransaction, fetchRTPWithdrawTransaction } = useFetchRTPWithdrawTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchRTPWithdrawTransaction(TransactionID)
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = rtpWithdrawTransaction;

  return (
    <div>
      {transaction && (
        <RTPWithdrawalInfo
          transaction={transaction}
          Notes={Notes}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
